enum GetAvailableUtilRawsActionType {
  Add = 0,
  Correct = 1,
  Split = 2,
}
export default GetAvailableUtilRawsActionType;
